<template>
  <section class="py-4 px-4" :style="{ backgroundColor: backgroundColor }">
    <div class="flex gap-4 justify-center">
      <button 
        @click="handleFindMore"
        class="bg-[#FFA200] text-black font-bold text-lg px-8 py-3 rounded-lg hover:bg-[#e69500] transition-colors duration-200 flex items-center"
      >
        {{ footerTexts.findMore }}
        <span class="ml-2">></span>
      </button>
      
      <button 
        @click="handleInquiry"
        class="bg-[#FFA200] text-black font-bold text-lg px-8 py-3 rounded-lg hover:bg-[#e69500] transition-colors duration-200 flex items-center"
      >
        {{ footerTexts.inquiry }}
        <span class="ml-2">></span>
      </button>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { pushToDataLayer } from '../utils/gtm';

// 定义 props
const props = defineProps<{
  backgroundColor?: string;
}>();

const { locale, messages } = useI18n();
const router = useRouter();
const route = useRoute();

const footerTexts = computed(() => {
  return messages.value[locale.value]?.footer || {
    findMore: 'Find More',
    inquiry: 'Inquiry'
  };
});

const handleFindMore = () => {
  const targetPath = "/core-offers";
  
  if (route.path === targetPath) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    router.push(targetPath);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  
  pushToDataLayer('click', {
    category: 'action-buttons',
    label: targetPath,
  });
};

const handleInquiry = () => {
  const targetPath = "/contact-us";
  
  if (route.path === targetPath) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    router.push(targetPath);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  
  pushToDataLayer('click', {
    category: 'action-buttons',
    label: targetPath,
  });
};
</script>
